import {fetch, post, destroy} from '../api_utils';
import {isValidId} from '../utils';

export const rivalMonitorsGet = rivalId => {
  const params = {
    rivalIds: [rivalId],
    startDate: '2000-01-01',
    limit: 500
  };

  return new Promise((resolve, reject) => {
    fetch('/api/monitors.json', {code: 'ApiUtils.rivalMonitorsGet', params})
      .then(({data: {items}}) => {
        resolve(items.sort((a, b) => {
          const aTitle = a?.title || '';
          const bTitle = b?.title || '';

          if(bTitle === aTitle) {
            return new Date(a.createdAt) - new Date(b.createdAt);
          }

          if(aTitle < bTitle) {
            return -1;
          }

          return 1;
        }));
      }).catch(err => reject(err));
  });
};

export const rivalMonitorCreate = ({rivalId, url}) => {
  const params = {
    rivalId,
    url,
    highlightsMode: false
  };

  return new Promise((resolve, reject) => {
    post('/api/monitor.json', JSON.stringify(params), {code: 'ApiUtils.rivalMonitorCreate'})
      .then(result => resolve(result))
      .catch(err => reject(err));
  });
};

export const rivalMonitorDelete = ({id}) => {
  if(!isValidId(id)) {
    return Promise.reject('ApiUtils.rivalMonitorDelete invalid parameters');
  }

  return destroy(`/api/monitor/${id}.json`, {code: 'ApiUtils.rivalMonitorDelete'});
};

export const monitorGet = (id, params) => {
  if(!isValidId(id)) {
    return Promise.reject('ApiUtils.monitorGet invalid parameters');
  }

  return fetch(`/api/monitor/${id}.json`, {code: 'ApiUtils.monitorsGet', params})
    .then(({data}) => data);
};
